// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U5Fb","question":"styles_question__3V2HN","inputVisibleButton":"styles_inputVisibleButton__1WQD4","note":"styles_note__18PNC"};